import { useRole } from '@/hooks/useRole';
import { Box, Flex, Spinner } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Layout from '../common/Layout';
import AlertComponent from '../common/AlertComponent';
import { Outlet } from 'react-router-dom';
import { useGetJumpLinksQuery } from '@/app/services/nucleus';

const JumpLinks = () => {
  useRole('support');
  const [errorTitle, setErrorTitle] = useState('');
  const [errorDesc, setErrorDesc] = useState('');

  const { isLoading, isError, error: jumpLinksError } = useGetJumpLinksQuery();

  useEffect(() => {
    if (isError) {
      setErrorTitle('Jump Links Error');
      setErrorDesc(jumpLinksError?.data?.detail);
    }
  });

  return (
    <Box data-test-id="pact-jump-links">
      <Layout pageTitle={'Pact'}>
        {isLoading ? (
          <Flex alignItems="center" justifyContent="center" py={200}>
            <Spinner color="brand.900" size="lg" />
          </Flex>
        ) : isError ? (
          <AlertComponent status="warning" title={errorTitle} description={errorDesc} />
        ) : (
          <Outlet />
        )}
      </Layout>
    </Box>
  );
};

export default JumpLinks;
